'use client';
import { FC, ReactNode, useState } from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { trpc } from '~/libs/client/trpcQuery';
import { createApiHttpLink } from '~/libs/trpc';

export const TRPCProvider: FC<{
  apiBaseUrl: string;
  disableRetry?: boolean;
  proxy?: boolean;
  children: ReactNode;
}> = ({ apiBaseUrl, disableRetry, proxy, children }) => {
  const [queryClient] = useState(() => {
    const opts = disableRetry
      ? {
          defaultOptions: {
            queries: {
              retry: 0,
              refetchOnWindowFocus: false,
            },
          },
        }
      : undefined;

    return new QueryClient(opts);
  });

  const [trpcClient] = useState(() =>
    trpc.createClient({
      links: [createApiHttpLink(apiBaseUrl, undefined, proxy ?? false)],
    }),
  );

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </trpc.Provider>
  );
};
